import { useEffect, useMemo, useRef, useState } from 'react';
import { RenderQuotePdfWorker } from './useRenderQuotePdfWorker';
import { QuotePdfProps } from '../components/FileManager/PdfGenerator';

export const useRenderQuotePdf = (props?: QuotePdfProps|null) => {
  const worker = useMemo(() => new RenderQuotePdfWorker(), []);

  const loadingRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!worker || !props) return;
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    worker
      .call({ props })
      .then(({ url }) => {
        setUrl(url);
        console.log('GENERATED PDF')
      })
      .finally(() => {
        loadingRef.current = false;
        setLoading(false)
      });
  }, [worker, props]);

  useEffect(() => {
    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);

  return useMemo(
    () => ({
      loading,
      url,
    }),
    [loading, url]
  );
};
